/******************************************
*  Author : Riccardo Di Dato
*  Created On : Mon Oct 17 2022
*  File : Subscription.ts
*******************************************/
export class Subscription {
    removal;
    closed = false;
    constructor(removal) {
        this.removal = removal;
    }
    isClosed() {
        return this.closed;
    }
    unsubscribe() {
        if (!this.isClosed()) {
            this.closed = true;
            this.removal();
        }
    }
}
